export default "__VITE_ASSET__DTtSMxXU__";